import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import _ from '../../../utils/ObjectUtils';
import {WhiteFormOption} from "../../../style/MUIThemes";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    ...WhiteFormOption
});

const PasswordField =
    ({
         label = "",
         value = "",
         error,
         disabled,
         width = "6",
         handleFieldChange,
         handleFieldFocus = () => { },
         handleFieldBlur = () => { },
         handleClickShowPassword = () => { },
         showPassword = false,
         themeName = "default"
     }) => {

        const whiteStyle = useStyles();
        const isWhiteTheme = themeName === 'white';

        return (
            <div className={"col-lg-" + width + ( width < 6 ? " col-md-6 " : " col-md-12 " )}>
            <FormControl
                    className={classNames({[whiteStyle.root]: isWhiteTheme})}
                    error={!_.isNilOrEmpty(error)}
                >
                    <InputLabel
                        className={classNames({[whiteStyle.inputLabel]: isWhiteTheme})}
                        htmlFor="adornment-password"
                    >
                        {label}
                    </InputLabel>
                    <Input
                        id="adornment-password"
                        type={showPassword ? "text" : "password"}
                        className={classNames({[whiteStyle.input]: isWhiteTheme})}
                        value={value}
                        onChange={e => handleFieldChange(e.target.value)}
                        aria-describedby="password-helper-text"
                        onFocus={handleFieldFocus}
                        onBlur={handleFieldBlur}
                        autoComplete="new-password"
                        inputProps={{
                            "aria-label": "password",
                        }}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    className={classNames({[whiteStyle.iconButton]: isWhiteTheme}, "no-padding")}
                                    aria-label="Toggle password visibility"
                                    onClick={handleClickShowPassword}
                                >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <FormHelperText id="password-helper-text">{error}</FormHelperText>
                </FormControl>
            </div>
        );
    };

PasswordField.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    themeName: PropTypes.string,
    showPassword: PropTypes.bool,
    isFocused: PropTypes.bool,
    handleFieldBlur: PropTypes.func,
    handleFieldFocus: PropTypes.func,
    handleClickShowPassword: PropTypes.func,
    handleFieldChange: PropTypes.func.isRequired
};

export default PasswordField;